<template>
  <v-row align="center">
    <v-col cols="12">
      <v-row no-gutters align="center">
        <v-col cols="3" class="text-right mr-3">
          <ejs-radiobutton
            :label="lblOnDayLable"
            name="radioGroup"
            :checked="recurrenceOnDay.selectedValue === 0"
            @change="onChange(0)"
          ></ejs-radiobutton>
        </v-col>
        <v-col cols="3" class="text-left pr-3" v-if="repeatType === 'year'">
          <month-selector
            v-model="recurrenceOnDay.selectedMonth"
            :disabled="!isDisabledOnTheComponent"
          ></month-selector>
        </v-col>
        <v-col cols="2">
          <repeat-every
            v-model.number="recurrenceOnDay.day"
            :disabled="!isDisabledOnTheComponent"
            :max="31"
            id="onDayInput"
            :maxLength="2"
          ></repeat-every>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-row no-gutters align="center">
        <v-col cols="3" class="text-right mr-3">
          <ejs-radiobutton
            :label="lblOnDTheLable"
            name="radioGroup"
            :checked="recurrenceOnDay.selectedValue === 1"
            @change="onChange(1)"
          ></ejs-radiobutton>
        </v-col>
        <v-col cols="3" class="pr-3">
          <v-select
            v-model="recurrenceOnDay.selectedWeekSlot"
            :items="weekSlot"
            item-text="text"
            item-value="value"
            label="Select"
            persistent-hint
            single-line
            hide-details=""
            outlined
            dense
            :disabled="isDisabledOnTheComponent"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="recurrenceOnDay.selectedWeekDay"
            :items="weeksDays"
            item-text="text"
            item-value="value"
            label="Select"
            persistent-hint
            single-line
            hide-details=""
            outlined
            dense
            :disabled="isDisabledOnTheComponent"
          ></v-select>
        </v-col>
        <v-col cols="5" v-if="repeatType === 'year'">
          <v-row no-gutters align="center">
            <v-col cols="1" class="ml-1 mr-1">of</v-col>
            <v-col cols="7">
              <month-selector
                v-model="recurrenceOnDay.selectedMonth"
                :disabled="isDisabledOnTheComponent"
              ></month-selector>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
import { RadioButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { enableRipple } from "@syncfusion/ej2-base";
import MonthSelector from "./MonthSelector.vue";
import RepeatEvery from "./RepeatEvery.vue";

enableRipple(true);
Vue.use(RadioButtonPlugin);

export default {
  components: { MonthSelector, RepeatEvery },
  name: "OnTheDay",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    repeatType: String,
  },
  computed: {
    weeksDays() {
      return [
        { text: this.$t("lblSunday"), value: "sunday" },
        { text: this.$t("lblMonday"), value: "monday" },
        { text: this.$t("lblTuesday"), value: "tuesday" },
        { text: this.$t("lblWednesday"), value: "wednesday" },
        { text: this.$t("lblThursday"), value: "thursday" },
        { text: this.$t("lblFriday"), value: "friday" },
        { text: this.$t("lblSaturday"), value: "saturday" },
      ];
    },
    weekSlot() {
      return [
        { text: this.$t("lblFirst"), value: "first" },
        { text: this.$t("lblSecond"), value: "second" },
        { text: this.$t("lblThird"), value: "third" },
        { text: this.$t("lblFourth"), value: "fourth" },
        { text: this.$t("lblLast"), value: "last" },
      ];
    },
    lblOnDayLable() {
      return this.$t("lblOnDFay");
    },
    lblOnDTheLable() {
      return this.$t("lblOnDThe");
    },
    recurrenceOnDay: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    isDisabledOnTheComponent() {
      return Number(this.recurrenceOnDay.selectedValue) === 0;
    },
  },
  methods: { onChange },
};

function onChange(selectedValue) {
  this.recurrenceOnDay.selectedValue = selectedValue;
}
</script>

<style scoped>
@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css";

.e-radio-wrapper {
  margin-top: 18px;
}
</style>